import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { UserMasterService } from '../user-master.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-user-applicability-filter',
  standalone: true,
  imports: [NgSelectModule, CommonModule, FormsModule],
  templateUrl: './user-applicability-filter.component.html',
  styleUrl: './user-applicability-filter.component.scss'
})
export class UserApplicabilityFilterComponent {

  isDisabled: boolean = false;
  @Input() Title: string = '';
  @Input() WebESSUserApplicabilityMasterID = null;
  @Input() ShowFilter = {
    ShowBranch: false,
    ShowClient: false,
  }

  constructor(
    private activeModal: NgbActiveModal,
    private usermaster: UserMasterService
  ) { }

  ngOnInit(): void {
    if (this.ShowFilter.ShowBranch) {
      this.ApprovalComboLoad('BranchMasterForUserApplicability');
    }
    if (this.ShowFilter.ShowClient) {
      this.ApprovalComboLoad('ClientMasterForUserApplicability');
    }
  }

  Filter = {
    BranchID: 0,
    ClientID: 0,
    SiteID: 0,
    SearchText: null
  }

  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;

  ApprovalComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.usermaster.ComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'BranchMasterForUserApplicability') {
          this.Branchs = response.Table;
        } else if (Combotype == 'ClientMasterForUserApplicability') {
          this.Clients = response.Table;
        } else if (Combotype == 'SiteMasterForUserApplicability') {
          this.Sites = response.Table;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close() {
    this.activeModal.close(this.Filter);
  }

}
